export default "__VITE_ASSET__63a7aa41__"